import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05487c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = { class: "account-item-child" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title1" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "账户信息")
], -1))
const _hoisted_4 = {
  class: "recharge-it1",
  style: {"font-size":"12px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "account-item-child" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "苍鸾银行账户信息")
], -1))
const _hoisted_10 = { class: "recharge-it1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账户名：苍鸾（广州）信息技术有限公司", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开户行：中国工商银行股份有限公司深圳桥头支行", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账　号：4000 1157 0910 0393 121", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-item-child" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title3" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "温馨提示")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"padding":"20px","font-size":"12px"} }, [
    /*#__PURE__*/_createTextVNode(" 尊敬的客户您好！"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 当您向我司转账汇款时，应保持付款方名称与您在我司下单平台所注册账号的企业名称或个人姓名保持一致。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 若您上传的付款凭证所载信息中，付款方名称与注册账号的企业名称或个人姓名不一致，即视为您主动委托第三方向我司付款，您知晓并确认："),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 您保证委托第三方向我司付款的行为系您真实意思表示，并且保证受委托的第三方付款行为的合法性，如您委托第三方付款产生的一切法律纠纷以及给我司造成的损失，全部由您承担。我司因您委托第三方代付款而可能遭遇的第三方索赔并造成我司损失的，我司有权全额向您追偿。"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "充值记录查询")
], -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_upload_bank = _resolveComponent("upload-bank")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 24,
          class: "recharge"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "recharge-card" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", null, "登录账号：" + _toDisplayString(_ctx.email), 1),
                                _createElementVNode("span", null, "客户编号：" + _toDisplayString(_ctx.userMsg.userCode), 1),
                                _createElementVNode("span", null, "注册日期：" + _toDisplayString(_ctx.userMsg.createdAt), 1),
                                _createElementVNode("span", null, "账户状态：" + _toDisplayString(_ctx.accountinfo.status == 1 ? '正常':'冻结'), 1),
                                (_ctx.accountinfo.accountType != 1 && _ctx.accountinfo.accountType != '')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "账户类型： " + _toDisplayString(_ctx.accountinfo.accountType == 1 ? '预付账户' : _ctx.accountinfo.accountType == 2 ?'账期账户' : ''), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.accountinfo.accountType != 1 && _ctx.accountinfo.accountType != '')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 账单周期：" + _toDisplayString(_ctx.changeTxt(_ctx.accountinfo.cycle, "cycle")), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.accountinfo.accountType != 1 && _ctx.accountinfo.accountType != '')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 结算周期：" + _toDisplayString(_ctx.accountinfo.paymentTerm) + "天 ", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "recharge-card" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 20 }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCopy('act')))
                                }, "复制")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 20 }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCopy('bank')))
                                }, "复制")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 20 }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCopy('num')))
                                }, "复制")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" 充值流程：客户汇款至苍鸾银行账户> "),
                            _createElementVNode("a", {
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleShowModal && _ctx.handleShowModal(...args)))
                            }, "客户上传汇款凭证"),
                            _createTextVNode("> "),
                            _createVNode(_component_a_tooltip, null, {
                              title: _withCtx(() => [
                                _createTextVNode("一般为一个工作日，实际以银行的转账时间为准")
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" 等待银行转账完成 "),
                                _createVNode(_component_exclamation_circle_outlined, { style: {"color":"#30629C"} })
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" >充值完成 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { style: {"margin-top":"10px"} }, {
      default: _withCtx(() => [
        _hoisted_15,
        _createVNode(_component_a_row, { style: {"margin":"10px 0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({ label: "凭证上传时间" }, _ctx.validateInfos.time), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      "value-format": "YYYY-MM-DD",
                      value: _ctx.modelRef.time,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.time) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _ctx.handleSearch
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          disabled: _ctx.$store.state.loading.loading,
                          onClick: _ctx.handleDownload
                        }, {
                          default: _withCtx(() => [
                            (_ctx.$store.state.loading.loading)
                              ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                              : _createCommentVNode("", true),
                            _createTextVNode("导出")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _ctx.handleShowModal
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("充值（上传汇款凭证）")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              style: {"width":"100%","min-height":"300px"},
              columns: _ctx.columns,
              dataSource: _ctx.list,
              loading: _ctx.loading,
              pagination: _ctx.pagination,
              scroll: {x: 'calc(100vw)'},
              size: "small",
              onChange: _ctx.handleTableChange
            }, _createSlots({ _: 2 }, [
              (_ctx.isT)
                ? {
                    name: "bodyCell",
                    fn: _withCtx(({column,text, record}) => [
                      (column.dataIndex === 'currency')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'cur')), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'rechargeAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber(record.rechargeAmount)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'receivedAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber(record.receivedAmount)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'serviceCharge')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber(record.serviceCharge)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'cashAvailable')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber(record.cashAvailable)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'creditAvailable')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber(record.creditAvailable)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'receivedType')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            _createTextVNode(_toDisplayString(record.receivedType == 1 ? '银行转账' : '-'), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'status')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 7,
                            onClick: ($event: any) => (_ctx.handleShow('status', record))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'status')) + " ", 1),
                            (record.status==3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " :" + _toDisplayString(_ctx.showTxt(record.remarks)), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["columns", "dataSource", "loading", "pagination", "scroll", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: _ctx.typeStr=='add'||_ctx.typeStr=='status'?'上传银行转账凭证':'提示信息',
      width: _ctx.typeStr=='add'||_ctx.typeStr=='status'?'50%':'40%',
      visible: _ctx.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
      footer: null,
      onCancel: _ctx.getFormData
    }, {
      default: _withCtx(() => [
        (_ctx.visible&&_ctx.typeStr!='msg')
          ? (_openBlock(), _createBlock(_component_upload_bank, {
              key: 0,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
              onHidden: _ctx.getFormData,
              typeStr: _ctx.typeStr,
              infoData: _ctx.infoData
            }, null, 8, ["visible", "onHidden", "typeStr", "infoData"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&_ctx.typeStr=='msg')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_ctx.isNum=='100')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createTextVNode("您尚未进行账号认证，请认证后再充值！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleGotoCheck && _ctx.handleGotoCheck(...args)))
                    }, "账号认证"),
                    _createTextVNode("”进行认证。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='101')
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _createTextVNode("您尚未进行合同签署，请签署后再充值！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleGotoCheck && _ctx.handleGotoCheck(...args)))
                    }, "合同签署"),
                    _createTextVNode("”进行签署。")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "width", "visible", "onCancel"])
  ]))
}